<body>
    <div class="container">
        <h1 class="title">Time-table Motores & Transmissão</h1>
        <form [formGroup]="form" (click)="stopPropagation($event)" (keyup)="stopPropagation($event)">
            <div class="trip-details">
                <label class="labels">VIAGEM</label>
                <input class="input-box form-control" type="text" placeholder="Nome da viagem" maxlength="20"
                    formControlName="trip">
            </div>

            <div class="trip-type">
                <legend class="labels">Classificação</legend>
                <div class="category">
                    <label for="dot-1">
                        <input type="radio" class="dot one" formControlName="classification" value="time-table">
                        <span>Time Table</span>
                    </label>
                    <label for="dot-2">
                        <input type="radio" class="dot two" formControlName="classification" value="extra">
                        <span>Extra</span>
                    </label>
                </div>
            </div>

            <div class="trip-details">
                <label class="labels">CHEGADA</label>
                <input class="input-box form-control" type="text" placeholder="hh:mm" minlength="5" maxlength="5"
                    formControlName="arrivalSLA" (input)="formatTime($event)">
            </div>
            <div class="trip-details">
                <label class="labels">SAÍDA</label>
                <input class="input-box form-control" type="text" placeholder="hh:mm" minlength="5" maxlength="5"
                    formControlName="departureSLA" (input)="formatTime($event)">
            </div>

            <div class="extra-trip">
                <label class="labels">TAKT (Viagem Extra)</label>
                <input class="input-box form-control" type="text" placeholder="hh:mm" maxlength="5"
                    formControlName="extra" (input)="formatTime($event)">
            </div>

            <div class="common-trip">
                <div class="form-group">
                    <label class="labels">Processo</label>
                    <select class="input-box form-control" formControlName="process">
                        <option *ngFor="let process of processOptions" [value]="process">{{process}}</option>
                    </select>
                </div>
            </div>

            <div class="action-buttons">
                <button (click)="isNewTrip() ? submitForm() : updateTrip()" class="btn-save">
                    {{ isNewTrip() ? 'Salvar' : 'Atualizar' }}
                </button>
                <button (click)="resetForm()" class="btn-clear">Limpar</button>
            </div>
            <div class="close-div">
                <button (click)="onClose()" class="btn-cs">Sair</button>
            </div>
        </form>
    </div>
</body>